export default {
    addNewAccessPoint: 'Add a new Access Point',
    mainInfo: 'Main Info',
    selectSite: 'Select Site',
    accessGroup: 'Access Group',
    accessPointDetails: 'Access Point Details',
    addAccessPoint: 'Add Access Point',
    removeConfirm: 'Deleting will disable access and cause errors, are you sure this is not being used today?',
};
